import {
  hideCentralHaloMilgrain
} from '../../../../utils/jewelry-validation'

export const validateCentreHaloFields = (filters) => {
  let haloWidth = filters.central_halo_width && filters.central_halo_width === 'custom' ? 'central_halo_custom_width' : 'central_halo_width'
  const fieldNames = [
    'central_halo_style',
    haloWidth,
    'central_halo_quality',
    'central_halo_setting_style'
  ]

  const fieldErrorMsgMapping = {
    'central_halo_style': 'Centre Halo Type',
    'central_halo_quality': 'Quality of Diamonds in Centre Halo',
    'central_halo_setting_style': 'Centre Halo Setting Style',
    'central_halo_milgrain': 'Centre Halo Milgrain',
    'central_halo_width': 'Centre Halo Width (Per Row)',
    'central_halo_custom_width': 'Centre Halo Custom Width'
  }

  // if central_halo_milgrain field is not hidden, then it should be validated
  if (!hideCentralHaloMilgrain(filters)) {
    fieldNames.push('central_halo_milgrain')
  }

  let missingFields = fieldNames.filter((e) => { return filters[e] === null })
  return missingFields.map((field) => {
    return fieldErrorMsgMapping[field]
  })
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/centre-halo-fields/index.js